/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a list of labels and values to build a pie chart showing each part's share of the whole. Percentages are calculated automatically.`)
};

const es_pie_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una lista de etiquetas y valores para crear un gráfico circular que muestre la proporción de cada parte respecto al total. Los porcentajes se calculan automáticamente.`)
};

const de_pie_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine Liste von Bezeichnungen und Werten ein, um ein Kreisdiagramm zu erstellen, das den Anteil jedes Teils am Ganzen zeigt. Prozentsätze werden automatisch berechnet.`)
};

const nl_pie_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een lijst met labels en waarden om een cirkeldiagram te bouwen dat het aandeel van elk deel in het geheel toont. Percentages worden automatisch berekend.`)
};

const fr_pie_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une liste d'étiquettes et de valeurs pour créer un diagramme circulaire montrant la part de chaque élément dans le tout. Les pourcentages sont calculés automatiquement.`)
};

const it_pie_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un elenco di etichette e valori per costruire un grafico a torta che mostra la quota di ciascuna parte sul totale. Le percentuali vengono calcolate automaticamente.`)
};

const pt_br2_pie_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma lista de rótulos e valores para criar um gráfico de pizza mostrando a participação de cada parte no total. Os percentuais são calculados automaticamente.`)
};

const pt_pie_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma lista de rótulos e valores para construir um gráfico circular que mostra a fração de cada parte no todo. As percentagens são calculadas automaticamente.`)
};

const ja_pie_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベルと値のリストを貼り付けると、各部分が全体に占める割合を示す円グラフが作成されます。パーセンテージは自動的に計算されます。`)
};

const zh_pie_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴一系列标签和数值以构建饼图，展示每部分在整体中的占比。百分比会自动计算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_intro", locale)
	if (locale === "en") return en_pie_intro(inputs)
	if (locale === "es") return es_pie_intro(inputs)
	if (locale === "de") return de_pie_intro(inputs)
	if (locale === "nl") return nl_pie_intro(inputs)
	if (locale === "fr") return fr_pie_intro(inputs)
	if (locale === "it") return it_pie_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pie_intro(inputs)
	if (locale === "pt") return pt_pie_intro(inputs)
	if (locale === "ja") return ja_pie_intro(inputs)
	return zh_pie_intro(inputs)
};